import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    assignmentId: undefined,
    modal: false
};

const assignmentSlice = createSlice({
    name: "assignment",
    initialState,
    reducers: {
        assignmentEditMode: (state, action) => {
            if (state.assignmentId === action.payload) {
                state.assignmentId = undefined
            } else {
                state.assignmentId = action.payload
            }
        },
        assignmentAddModal: (state, action) => {
            if (state.modal) {
                state.modal = false
            } else {
                state.modal = true
            }
        }
    },
});

export const { assignmentEditMode, assignmentAddModal } = assignmentSlice.actions;
export default assignmentSlice.reducer;
